
import { useQuery } from "react-query";
import { getProdCodeTypes } from "../../../../actions/Utilities/Common";

export const useGetProdType = () => {
  return useQuery("GetProducerCodeType", getProdCodeTypes, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
